enum OverbiteType {
  'OPEN' = 'OPEN',
  'DEEP' = 'DEEP',
}

export { OverbiteType }
